'use strict'
module.exports = {
  BASE_API: '"https://checkup.anyoujc.cn/Api_Admin"',
  	NODE_ENV: '"production"'
}



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = rBKV
// module chunks = 2